<!-- 查看视频 -->
<template>
  <div id="video">
    <!--    <video-player id="video"-->
    <!--                  ref="video"-->
    <!--                  class="video-player vjs-custom-skin"-->
    <!--                  :options="playerOptions"-->
    <!--                  controls-->
    <!--                  @ended="onPlayerEnded"-->
    <!--                  @pause="onPlayerPause"-->
    <!--                  @play="onPlayerPlay"-->
    <!--                  preload="auto"></video-player>-->
    <!--    <el-link type="info" style="float: right;" @click="this.$parent.gotoIndex()">返回</el-link>-->
    <vue-aliplayer-v2
      class="video"
      ref="VueAliplayerV2"
      @play="onPlayerPlay"
      @pause="onPlayerPause"
      @ended="onPlayerEnded"
      :options="options"
    />
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      videoReadList: [],
      videoState: false,
      url: '',
      videoAss: null,
      options: {
        source: '',
        isLive: true, // 切换为直播流的时候必填
        autoplay: true,
        preload: true,
        // controlBarVisibility: 'always', 显示底部面板 测试时解开
        // videoWidth: 'auto',
        width: '1000px',
        height: '800px'
        // skinLayout: false
        // format: 'm3u8'  //切换为直播流的时候必填
      },
      show: true,
      isShowMultiple: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4', // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      }
    }
  },
  methods: {
    // 播放回调
    onPlayerPlay (players) {
      if (this.$route.query.src.state !== 1) {
        this.videoState = true
      }
      console.log('player play!')
    },
    // 暂停回调
    onPlayerPause (player) {
      console.log('player pause!', player)
    },
    // 视频播完回调
    onPlayerEnded ($event) {
      this.videoState = false
      this.$notify({
        title: '提示',
        type: 'success',
        message: '视频播放完成',
        offset: 100,
        duration: 2000
      })
      if (this.$route.query.src.state === 2) { // 只有必看视频才需要执行以下函数
        this.updatePlayed(this.$route.query.src.id)
      }
      // 将视频id 存到用户 played 表中
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting ($event) {
    },
    // 已开始播放回调
    onPlayerPlaying ($event) {
    },
    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata ($event) {
    },
    // 当前播放位置发生变化时触发。
    onPlayerTimeupdate ($event) {
    },
    // 媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay (player) {
      // console.log('player Canplay!', player)
    },
    // 媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough (player) {
      // console.log('player Canplaythrough!', player)
    },
    // 播放状态改变回调
    playerStateChanged (playerCurrentState) {
      console.log('player current update state', playerCurrentState)
    },
    // 将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied (player) {
      console.log('example player 1 readied', player)
    },
    // 将用户已播放的视频更新存入到数据库
    updatePlayed (id) {
      let user = this.global.user_info
      let list = this.global.videoReadList

      if (list === null || list === undefined) {
        list = []
      }
      // eslint-disable-next-line eqeqeq
      if (list.indexOf(id) != -1) {
        return
      }
      list.push(id)
      // this.global.videoReadList = list
      let msg = {}
      msg.id = user.id
      msg.videoId = id // 用户已播放的视频id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.updatePlayedfn
      sendData.vm = this
      req.Post('user/updatePlayed', sendData)
    },
    updatePlayedfn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
    },
    xxx (key) {
      let v = this.$refs.VueAliplayerV2
      if (key === 39) {
        var videotimes = v.getDuration()
        var playnum = v.getCurrentTime()
        playnum = parseInt(playnum + 10)
        if (playnum <= (videotimes + 30)) {
          v.seek(playnum)
        }
      } // LEFT
      if (key === 37) {
        var videotimes2 = v.getDuration()
        var playnum2 = v.getCurrentTime()
        playnum = parseInt(playnum - 10)
        if (playnum2 <= (videotimes2 - 30)) {
          v.seek(playnum2)
        }
      } // LEFT
    }
  },
  mounted () {
    // DANGER 仅仅在测试是打开
    // this.$nextTick(() => {
    //   let _this = this
    //   document.onkeydown = function (e) {
    //     let key = window.event.keyCode
    //     _this.xxx(key)
    //   }
    // })
  },
  created () {
    // eslint-disable-next-line eqeqeqD
    if (this.global.station_id === 29) { // 测试账号
      this.options.isLive = false
    }
    this.options.source = this.$route.query.src.path
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.options.source = vm.$route.query.src.path
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next(() => {
      this.videoState = false
    })
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video {
  background: black;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

#video {
  background: black;
  display: block;
  height: 100%;
  width: 100%;
  z-index: 100;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/page/video.vue